<template>
  <div class="posts">
    <table class="anz-table anz-table--hover anz-mb-xl">
      <user-header />
      <tbody>
        <template v-for="bannedUser in bannedUsers" :key="bannedUser.id">
          <blocked-user-item
            :banned-user="bannedUser"
            @removed="removeBlockedUser"
          />
        </template>
      </tbody>
    </table>
    <div class="anz-align-center">
      <a-loader v-if="loading" class-name="my-l"></a-loader>
      <a-button
        v-if="hasNext"
        class-name="anz-btn anz-btn-primary anz-wf-mo anz-btn-l"
        @click="loadNext"
      >
        <template #title>
          {{ $translate('profile.actions.loadNext') }}
          <template v-if="totalCount > loadedCount">
            ({{ totalCount - loadedCount }})
          </template>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useUserBlockLoader } from '@/composables/userBlock/userBlock'
import UserHeader from '@/components/Profile/Lists/Single/UserHeader.vue'
import AButton from '@/components/Forms/AButton.vue'
import BlockedUserItem from '@/components/Profile/Lists/Single/BlockedUserItem.vue'
import ALoader from '@/components/ALoader.vue'

export default defineComponent({
  name: 'BannedUsersList',
  components: { ALoader, BlockedUserItem, AButton, UserHeader },
  async setup() {
    const {
      loadNext,
      bannedUsers,
      loading,
      hasNext,
      loadedCount,
      totalCount,
      removeBlockedUser,
      clear,
    } = useUserBlockLoader()

    clear()
    await loadNext()

    return {
      loadedCount,
      totalCount,
      loading,
      hasNext,
      loadNext,
      removeBlockedUser,
      bannedUsers,
    }
  },
})
</script>
